<!--
  Project-wide confirm dialog. Consumers use the `confirm(message)` inject
  (see EmployerLayout.vue setup). The inject resolves a Promise<boolean>
  when the user chooses Cancel or Yes.

  Internals migrated from custom CSS to Shadcn Dialog + Button + Tailwind
  so the whole app's modal chrome shares one visual language.
-->
<template>
    <Dialog :open="confirmState.show" @update:open="v => !v && cancel()">
        <DialogContent class="max-w-md">
            <DialogHeader>
                <DialogTitle>Confirm</DialogTitle>
                <DialogDescription>{{ confirmState.message }}</DialogDescription>
            </DialogHeader>
            <DialogFooter class="gap-2 sm:gap-2">
                <Button variant="outline" @click="cancel">Cancel</Button>
                <Button variant="destructive" @click="yes">Yes, continue</Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script>
export default {
    name: 'ConfirmModal',
    inject: {
        confirmState: { default: () => ({ show: false, message: '', resolve: null }) }
    },
    methods: {
        yes() {
            this.confirmState.show = false;
            var resolve = this.confirmState.resolve;
            this.confirmState.resolve = null;
            if (resolve) resolve(true);
        },
        cancel() {
            this.confirmState.show = false;
            var resolve = this.confirmState.resolve;
            this.confirmState.resolve = null;
            if (resolve) resolve(false);
        }
    }
};
</script>
